<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo Tipo na parte cadastro de Status do Menu Plano  ==================------->

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome Tipo</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome Tipo"
            id="Nome Tipo"
            v-model="formCadastro.nomeTipo"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Tipo'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Tipo'
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Icone SVG (32 x 32)</div>
          <vs-textarea
            class="w-full"
            name="Icone"
            id="Icone"
            rows="6"
            v-model="formCadastro.icone"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Icone')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Icone')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idTipo == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import utilsList from "../../../../utils/list";
import { Money } from "v-money";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
    contadorRender(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      files: new FormData(),
      icone: null,
      activePromptValor: false,
      aguardeCadastro: false,
      valorBeneficio: 0,
      situacoes: ["Ativo", "Inativo"],
      languages: lang,
      funcoesValicao: null,
      formCadastro: {
        idTipo: null,
        nomeTipo: null,
        status: true,
        icone: null,
      },
    };
  },
  methods: {
    chooseFiles() {
      document.getElementById("fileUpload").click();
      //this.$refs.fileUploadBtn.click();
      console.log(document.getElementById("fileUpload"));
    },
    selecionaIcone(event) {
      console.log(event);
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      console.log(files[0]);
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.icone = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "Icone", this.files)
        .then((response) => {
          this.formCadastro.icone = response;
          console.log(response);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    formataValor(valor) {
      var retorno = this.$options.filters.currency(valor);
      return retorno;
    },
    preencheBeneficio() {
      if (this.beneficio.length == 0) {
        return "";
      } else {
        return this.beneficio.label;
      }
    },
    clearFormGrupo() {
      this.activePromptValor = false;
      this.beneficio = [];
    },
    deletetaTiposBeneficio(idBeneficio) {
      let array = this.TiposBeneficios;
      for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].idBeneficio == idBeneficio) {
          array.splice(i, 1);
        }
      }
    },
    preencheForm() {
      if (this.dados.idTipo) {
        this.formCadastro.idTipo = this.dados.idTipo;
        this.formCadastro.nomeTipo = this.dados.nomeTipo;
        this.formCadastro.icone = this.dados.icone;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
      } else {
        this.resetForm();
      }
    },

    onSubmit() {
      var action = "Atualizar/" + this.formCadastro.idTipo;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idTipo) {
        action = "Adicionar";
        metodo = "post";
        msgRetorno = "Tipo Adicionado com sucesso";
      }
      var objSend = { ...this.formCadastro };

      console.log(objSend);

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("TipoCaixa", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },
    resetForm() {
      this.TiposBeneficios = [];
      this.formCadastro = {
        idTipo: null,
        nomeTipo: null,
        status: true,
        icone: null,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
    Money,
  },
};
</script>
<!------------ END SCRIPT ------------>
